import { getDefaultConfig } from "@rainbow-me/rainbowkit";
import { http } from "wagmi";
import { injected } from "wagmi/connectors";
import { bscTestnet } from "viem/chains";

export const rainbowKitConfig = getDefaultConfig({
  appName: "My Dapp",
  projectId: "7d9362f81eab5d1a512bd5ad3313a692",
  chains: [bscTestnet],

  connectors: [
    injected({
      shimDisconnect: true
    })
  ],

  transports: {
    [bscTestnet.id]: http("https://data-seed-prebsc-1-s1.binance.org:8545/")
  },
  ssr: false
});
